import React from 'react'
import FAB from '../FAB/FAB'

import './style.scss'

const Footer = props => {

  return (

    <footer className="footer-main">
      {/*<FAB />*/}
      <div className="copyrights-container">
        <div className="copyrights-content">
          <p>copyright &copy; {new Date().getFullYear()} <b>digital corps</b></p>
        </div>
      </div>
    </footer>
  )
}

export default Footer